import { LICENSED_PRODUCTS } from '@atlassian/jira-common-util-get-tenant-context';
import { useLicensedProducts } from '@atlassian/jira-tenant-context-controller';

export const useTenantHasConfluence = () => {
	const licensedProducts = useLicensedProducts();

	return Boolean(licensedProducts[LICENSED_PRODUCTS.CONFLUENCE]);
};
